module.exports = __webpack_public_path__ + "static/media/Rectangle 61.0a47014f.png";